export default __webpack_public_path__ + "static/media/aroma10.00e70802.png";